/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _join = _interopRequireDefault(require("../packages/join"));
var prepareClassName = function prepareClassName(computedProps) {
  var visibleColumns = computedProps.visibleColumns,
    computedShowCellBorders = computedProps.computedShowCellBorders,
    computedShowZebraRows = computedProps.computedShowZebraRows,
    theme = computedProps.theme,
    rtl = computedProps.rtl,
    viewportAvailableWidth = computedProps.viewportAvailableWidth,
    totalComputedWidth = computedProps.totalComputedWidth,
    computedFocused = computedProps.computedFocused,
    computedShowHoverRows = computedProps.computedShowHoverRows,
    nativeScroll = computedProps.nativeScroll,
    focusedClassName = computedProps.focusedClassName,
    computedFilterable = computedProps.computedFilterable,
    computedShowHeaderBorderRight = computedProps.computedShowHeaderBorderRight,
    virtualizeColumns = computedProps.virtualizeColumns,
    className = computedProps.className,
    stickyHeader = computedProps.stickyHeader;
  return (0, _join.default)('InovuaReactDataGrid', className, theme && "InovuaReactDataGrid--theme-".concat(theme), virtualizeColumns && 'InovuaReactDataGrid--virtualize-columns', nativeScroll && 'InovuaReactDataGrid--native-scroll', visibleColumns.length && 'InovuaReactDataGrid--columns-ready', computedShowZebraRows && 'InovuaReactDataGrid--zebra-rows', computedFilterable && 'InovuaReactDataGrid--filterable', computedFocused && 'InovuaReactDataGrid--focused', computedShowHoverRows && 'InovuaReactDataGrid--show-hover-rows', rtl ? 'InovuaReactDataGrid--direction-rtl' : 'InovuaReactDataGrid--direction-ltr', computedFocused && focusedClassName, computedShowHeaderBorderRight ? 'InovuaReactDataGrid--show-header-border-right' : 'InovuaReactDataGrid--no-header-border-right', viewportAvailableWidth > totalComputedWidth && 'InovuaReactDataGrid--show-border-right', computedShowCellBorders && (computedShowCellBorders === true ? 'InovuaReactDataGrid--cell-borders-horizontal InovuaReactDataGrid--cell-borders-vertical' : "InovuaReactDataGrid--cell-borders-".concat(computedShowCellBorders)), stickyHeader && 'InovuaReactDataGrid--sticky-header');
};
var _default = prepareClassName;
exports.default = _default;